import { createSlice } from "@reduxjs/toolkit";

export const premiumTrialSlice = createSlice({
  name: "premiumTrial",
  initialState: {
    visible: false,
    title: "",
    description: "",
    trialDesafios: localStorage.getItem("SPICY_TRIAL_DESAFIOS")
      ? parseInt(localStorage.getItem("SPICY_TRIAL_DESAFIOS"))
      : 4,
    trialRoleta: localStorage.getItem("SPICY_TRIAL_ROLETA")
      ? parseInt(localStorage.getItem("SPICY_TRIAL_ROLETA"))
      : 4,
    trialSolo: localStorage.getItem("SPICY_TRIAL_SOLO")
      ? parseInt(localStorage.getItem("SPICY_TRIAL_SOLO"))
      : 4,
  },
  reducers: {
    setVisible: (state, action) => {
      state.visible = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setDescription: (state, action) => {
      state.description = action.payload;
    },
    spendTrialDesafios: (state) => {
      if (state.trialDesafios > 0) {
        state.trialDesafios -= 1;
        localStorage.setItem("SPICY_TRIAL_DESAFIOS", state.trialDesafios);
      }
    },
    spendTrialRoleta: (state) => {
      if (state.trialRoleta > 0) {
        state.trialRoleta -= 1;
        localStorage.setItem("SPICY_TRIAL_ROLETA", state.trialRoleta);
      }
    },
    spendTrialSolo: (state) => {
      if (state.trialSolo > 0) {
        state.trialSolo -= 1;
        localStorage.setItem("SPICY_TRIAL_SOLO", state.trialSolo);
      }
    },
  },
});

export const {
  setVisible,
  setDescription,
  setTitle,
  spendTrialDesafios,
  spendTrialRoleta,
  spendTrialSolo,
} = premiumTrialSlice.actions;

export default premiumTrialSlice.reducer;
